import {DomSanitizer} from '@angular/platform-browser';
import {PipeTransform, Pipe, SecurityContext} from '@angular/core';
import DOMPurify from 'dompurify';

@Pipe({ name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value: string, ...args: any[] ) {
    //Wenn args[0] true ist wird alles zugelassen ohne auf XXS zu achten
    if(args[0]) return this.sanitized.bypassSecurityTrustHtml(value);
    return this.sanitized.bypassSecurityTrustHtml(DOMPurify.sanitize(value, {USE_PROFILES: {html: true}}))

    // return this.sanitized.sanitize(SecurityContext.HTML, value)

  }
}